import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router';
import { useLanguageContext } from 'store/language';

import { useQuery } from 'react-query';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import API from 'core/Api';
import ManuallyEdit from 'routes/client/leaves/components/ManuallyEdit';
import { ITableFilter } from 'components/table/types';
import { ILeave } from '../../types';

const Screen: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { language } = useLanguageContext();
  const { id } = useParams<{ id: string | undefined }>();
  interface ISelectOptionProps {
    label: string;
    value: string | number | boolean;
  }

  interface IFormDropdowns {
    types: ISelectOptionProps[];
    paid_sub_types: ISelectOptionProps[];
    additional_sub_types?: ISelectOptionProps[];
  }
  const { client } = useActiveClientContext();
  const {
    isFetching,
    isLoading: isLoadingLeavesDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<{ [key: string]: ISelectOptionProps[] }, Error>(
    [buildClientEntity('leaves-dropdowns', client)],
    (): Promise<{ [key: string]: ISelectOptionProps[] }> => {
      return API.get('leaves/dropdown-options?all-users=true').then(res => {
        const filters = res.data && res.data[language || 'bg'];
        return {
          ...filters,
          status: filters.status.map((filter: ITableFilter) => {
            if (
              filter.value === 'rejected' ||
              filter.value === 'confirmed' ||
              filter.value === 'employeeRejectInitiated'
            )
              return {
                ...filter,
                selected: true,
              };

            return filter;
          }),
        };
      });
    },
    {
      cacheTime: 0,
    }
  );

  const {
    isLoading: isLoadingFormDropdowns,
    error: errorFormDropdowns,
    data: ManuallyInsertFormDropdowns,
  } = useQuery<IFormDropdowns, Error>(
    [buildClientEntity('employee-leaves-dropdowns', client)],
    (): Promise<IFormDropdowns> => {
      return API.get('leaves/types/dropdown-options?all=true').then(
        res =>
          res.data && {
            ...res.data,
          }
      );
    }
  );

  const FormDropdowns = useMemo(() => {
    return {
      user: dropdowns?.user ?? [],
      types: ManuallyInsertFormDropdowns?.types ?? [],
      paidSubTypes: ManuallyInsertFormDropdowns?.paid_sub_types ?? [],
      additionalSubTypes: ManuallyInsertFormDropdowns?.additional_sub_types ?? [],
    };
  }, [ManuallyInsertFormDropdowns, dropdowns]);

  const { isLoading, error, data } = useQuery<ILeave, Error>(
    [buildClientEntity('leave', client), { id }],
    (): Promise<ILeave> =>
      API.get(`leaves/?id=${id}`).then(res => {
        if (res.data && res.data.items.length === 0) throw new Error('Не съществува такава отпуска');
        return res.data.items[0];
      }),
    {
      retry: false,
    }
  );

  return (
    <>
      {FormDropdowns &&
        FormDropdowns.user.length > 0 &&
        FormDropdowns.types.length > 0 &&
        FormDropdowns.paidSubTypes.length > 0 &&
        FormDropdowns.additionalSubTypes.length > 0 &&
        data && (
          <ManuallyEdit
            // @ts-ignore
            title={t('leaves.manuallyEditLeave')}
            dropdowns={FormDropdowns}
            leave={data}
          />
        )}
    </>
  );
};

export default Screen;
